import type { ReduxStateType } from 'Core/store';
import type { AutocompleteItem } from 'Models';

const autocompleteSelector = (state: ReduxStateType): ReduxStateType['autocomplete'] => state.autocomplete;

export const autocompleteIsLoadingSelector = (state: ReduxStateType): boolean =>
  autocompleteSelector(state).isLoading;

// default suggestions

export const autocompleteDefaultSuggestionsSelector = (state: ReduxStateType): AutocompleteItem[] | null =>
  autocompleteSelector(state).defaultSuggestions;

// request

export const autocompleteRequestQuerySelector = (state: ReduxStateType): string =>
  autocompleteSelector(state).request.query;

// response

const autocompleteResponseSelector = (state: ReduxStateType) => autocompleteSelector(state).response;

const autocompleteResponseQuerySelector = (state: ReduxStateType): string =>
  autocompleteResponseSelector(state).query;

export const autocompleteResponseItemsSelector = (state: ReduxStateType): AutocompleteItem[] | null =>
  autocompleteResponseSelector(state).items;

export const autocompleteTotalHitsSelector = (state: ReduxStateType): number =>
  autocompleteResponseSelector(state).totalHits;

// redirect

const autocompleteRedirectSelector = (state: ReduxStateType) => autocompleteSelector(state).redirect;

export const autocompleteRedirectWaitingForResponseSelector = (state: ReduxStateType): boolean =>
  autocompleteRedirectSelector(state).waitingForResponse;

export const autocompleteRedirectPreventedSearchSelector = (state: ReduxStateType): boolean =>
  autocompleteRedirectSelector(state).havePreventedSearch;

// combined

export const autocompleteResponseReceivedSelector = (state: ReduxStateType): boolean =>
  autocompleteRequestQuerySelector(state) === autocompleteResponseQuerySelector(state);
